import screenSize$ from './screenSize$'

export default screenSize$
    .map(({ width, height }) => (width > height ? 'landscape' : 'portrait'))
    .distinctUntilChanged()
    .deliverLast()
